
const bjenv ='uat';
const env='uat';
const bingjianServerList={
   prd:'http://10.0.0.31/api/portal/common/home',
   uat:'http://10.0.0.68/api/portal/common/home',
   sit:'http://10.0.0.65/api/portal/common/home',
}
const serverUrl={

    //这是PRD

   prd:{
      esbPath:'58.214.26.250:6090/',
       path:'58.214.26.250:6080/',
      fullScreenPath:'10.0.0.89:8001/',
       project_id:'scp0008100037',
   },

   prd_local:{
      esbPath:'localhost:6090/',
      path:'localhost:6080/',
       fullScreenPath:'10.0.3.89:3000/',
       project_id:'scp0008100037',
   },

   uat_local:{
      esbPath:'localhost:6091/',
      path:'localhost:6081/',
       fullScreenPath:'10.0.0.89:8001/',
       project_id:'scp0021100023',
   },

  uat: {
     esbPath:'58.214.26.250:20080/',
     path:'58.214.26.250:20081/',
      fullScreenPath:'10.0.0.89:8001/',
      project_id:'scp0021100023',
  },
   sit:{
      esbPath:'58.214.26.250:20083/',
      path:'58.214.26.250:20082/',
       fullScreenPath:'10.0.0.89:8001/',
       project_id:'scp0117101471',
   },
   sit_local:{
      esbPath: 'localhost:6093/',
      path: 'localhost:6082/',
       fullScreenPath:'10.0.0.89:8001/',
       project_id:'scp0117101471',
   }



}

const serverUrlWithProtype ={}
//
let isHttps = 'https:' === document.location.protocol ? true : false;
const protocol =isHttps ? 'https://':'http://'

for(var key of Object.getOwnPropertyNames(serverUrl)){

    serverUrlWithProtype[key] = {esbPath:protocol + serverUrl[key]. esbPath,
        path:protocol + serverUrl[key]. path,
        fullScreenPath:protocol+serverUrl[key].fullScreenPath,
        project_id:serverUrl[key].project_id,
    }


}



const  serverWithoutProtocol =serverUrl[env];
const server =serverUrlWithProtype[env];
const bingJianUrl =bingjianServerList[bjenv];

export  {server,bingJianUrl,serverWithoutProtocol}
